import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { onAuthChange } from './services/firebase';
import { UserProvider } from './context/UserContext';
import { AppRoutes } from './routes';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Listen to auth state changes
  useEffect(() => {
    const unsubscribe = onAuthChange((currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // Show loading screen while checking auth
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <div className="text-white text-xl">Loading...</div>
      </div>
    );
  }

  return (
    <UserProvider value={user}>
      <Router>
        <div className="min-h-screen bg-gray-900 text-white flex flex-col">
          {/* Show navbar only when logged in */}
          {user && <Navbar />}
          
          {/* Main content */}
          <main className="flex-grow">
            <AppRoutes user={user} />
          </main>

          {/* Footer */}
          <Footer />
        </div>
      </Router>
    </UserProvider>
  );
}

export default App;